import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import HideAppBar from "../../../widgets/header/HideAppBar";
import {
	Accordion, AccordionActions,
	AccordionDetails,
	AccordionSummary, Button,
	Card,
	CardContent,
	CardHeader,
	Container, FormControl, InputLabel, MenuItem, Select
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from "@mui/material/Typography";
import TicketCard from "../details/TicketCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import useGetAllArchiviati from "../utils/useGetAllArchiviati";
import SollecitaTicket from "../storico/SollecitaTicket";
import {getTicketHistory} from "../../../../services/TicketServices";
import {TicketContext} from "../../../../App";
import {useForm} from "react-hook-form";
import {
	codFRegisterNone,
	cognomeRegisterNone,
	nomeRegisterNone,
	phoneRegisterPrivate
} from "../../../../utils/RegisterUtils";
import {CODICE_FISCALE} from "../../../../strings/IT";
import CustomText from "../../../widgets/inputs/CustomText";
import {categoriesV2} from "../../../../utils/dictionaries/Categories";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {clean} from "../../../../utils/GenericUtils";


const ArchivioTicket = () => {
	const classes = BaseStyle();
	const [selected, setSelected] = useState("");
	const [sort, setSort] = useState("dataUltimaModifica");
	const [dir, setDir] = useState("DESC");
	const [pageNumber, setPageNumber] = useState(0);
	const [example, setExample] = useState({});
	const ticketContext = useContext(TicketContext);
	const {control, errors, getValues, watch} = useForm({mode: "onChange"})
	
	const {
		loading,
		error,
		hasMore,
		tickets
	} = useGetAllArchiviati(pageNumber, sort, dir, example);
	const observer = useRef();
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
				//getAllInfo(ticketContext.dispatch);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])
	
	const handleTicketSelect = useCallback((ticket) => {
		getTicketHistory(ticket, ticketContext.dispatch);
		setSelected(ticket.id);
	}, [ticketContext.dispatch]);
	
	useEffect(() => {
		document.body.style = `background: none;`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Archivio ticket"} back={true}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						
						<Grid item xs={12}>
							<Accordion style={{borderRadius: 24}}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon/>}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className={classes.heading}><b>Clicca per effettuare una ricerca più
										avanzata</b></Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Grid container spacing={3}>
										<Grid item xs={12}>
											<Typography variant={"subtitle1"}>
												<b>Ordinamento</b>
											</Typography>
										</Grid>
										
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => setSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"dataUltimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"lastModify"}>Operatore ultima modifica</MenuItem>
													<MenuItem value={"dataCreazione"}>Data creazione</MenuItem>
													<MenuItem value={"categoria"}>Categoria</MenuItem>
													<MenuItem value={"sottoCategoria"}>Sottocategoria</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => setDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più piccolo al più grande</MenuItem>
													<MenuItem value={"DESC"}>Dal più grande al più piccolo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										
										<Grid item xs={12}>
											<Typography variant={"subtitle1"}>
												<b>Anagrafica paziente</b>
											</Typography>
										</Grid>
										
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={codFRegisterNone}
												name={"soggetto.codF"}
												label={CODICE_FISCALE}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["codF"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={phoneRegisterPrivate}
												name={"soggetto.cell"}
												label={"Cellulare"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["cell"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={nomeRegisterNone}
												name={"soggetto.nome"}
												label={"Nome"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["nome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={cognomeRegisterNone}
												name={"soggetto.cognome"}
												label={"Cognome"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["cognome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={cognomeRegisterNone}
												name={"soggetto.patente"}
												label={"Patente"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["patente"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={cognomeRegisterNone}
												name={"soggetto.cartaIdentita"}
												label={"Carta d'identità"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["cartaIdentita"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={cognomeRegisterNone}
												name={"soggetto.passaporto"}
												label={"Passaporto"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["soggetto"]?.["passaporto"]}
											/>
										</Grid>
										
										<Grid item xs={12}>
											<Typography variant={"subtitle1"}>
												<b>Dati ticket</b>
											</Typography>
										</Grid>
										<Grid item xs={12} sm={3}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"id"}
												label={"ID ticket"}
												autoFocus={false}
												inputProps={{
													className: classes.input
												}}
												type={"text"}
												error={errors["id"]}
											/>
										</Grid>
										<Grid item xs={12} sm={9}>
											<CustomSelect
												name={"categoria"}
												label={"Seleziona una categoria"}
												control={control}
												defaultValue={""}
												autoFocus={false}
												none={true}
												noneValue={""}
												rules={{required: false}}
												error={errors["categoria"]}
											>
												{Object.entries(categoriesV2).sort((a, b) => {
													if (a["1"].label > b["1"].label) return 1;
													if (a["1"].label < b["1"].label) return -1;
													return 0
												}).map(([key, val]) => {
													return (
														<MenuItem value={key} key={key}>
															{val.label}
														</MenuItem>
													);
												})}
											</CustomSelect>
										</Grid>
										{
											categoriesV2[watch("categoria")]?.subCategories?.length > 0 &&
											<Grid item xs={12}>
												<CustomSelect
													name={"sottoCategoria"}
													label={"Quale di queste sottocategorie?"}
													control={control}
													defaultValue={""}
													autoFocus={false}
													none={true}
													noneValue={""}
													rules={{required: false}}
													error={errors["sottoCategoria"]}
												>
													{categoriesV2[watch("categoria")].subCategories.map((val, key) => {
														return (
															<MenuItem value={val} key={key}>
																{val.label}
															</MenuItem>
														);
													})}
												</CustomSelect>
											</Grid>
										}
									
									</Grid>
								</AccordionDetails>
								<AccordionActions>
									<Button variant={"contained"} color={"primary"} className={classes.roundButton} size={"small"}
									        disableElevation
									        onClick={() => {
										        let data = clean(getValues());
										        if (data.categoria) {
											        data.categoria = categoriesV2[data.categoria]?.label;
										        }
										        if (data.sottoCategoria) {
											        data.sottoCategoria = data.sottoCategoria.label
										        }
										        if (data.soggetto) {
											        data.soggetto = clean(data.soggetto);
										        }
										        setExample(data)
									        }}
									        style={{borderRadius: 24}}>
										<b>cerca</b>
									</Button>
								</AccordionActions>
							</Accordion>
						</Grid>
						
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									
									<div className={classes.content}>
										{
											tickets.map((ticket, index) => {
												if (tickets.length === index + 1) {
													return (
														<Card ref={lastTicketElementRef} key={ticket.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<TicketCard ticket={ticket} setValue={() => {
															}} handleTicketSelect={handleTicketSelect}/>
														</Card>
													)
												} else {
													return (
														<Card key={ticket.id} className={clsx(classes.roundBorder, classes.mailCard)}>
															<TicketCard ticket={ticket} setValue={() => {
															}} handleTicketSelect={handleTicketSelect}/>
														</Card>
													)
												}
											})
										}
										{!loading && !error && tickets.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono ticket! Goditi questo meritato relax
											</Alert>}
										{loading &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
										{error && !loading && <Alert severity="error" style={{borderRadius: 24}}>
											<AlertTitle>Errore</AlertTitle>
											Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
											sviluppatori.
										</Alert>}
									
									</div>
								
								</CardContent>
							</Card>
						</Grid>
					
					</Grid>
				
				</Container>
			</main>
            {
				selected !== "" &&
				<SollecitaTicket ticket={selected} open={selected !== ""} onClose={() => setSelected("")} canModify={false}
				                 isDiary={false} canRestore={true}/>
			}
        </React.Fragment>
    );
};

export default React.memo(ArchivioTicket)
